<template lang="pug">
.bloco-imovel
    .bloco-imovel__titulo
        .bloco-imovel__titulo--interno
            span Total de Imóveis:
            span.negrito {{ imoveisValor }}

    .bloco-imovel__conteudo
        .bloco-imovel__conteudo--esquerdo
            span.barra-topo Área:
            span.valor__negrito {{ areaValor }}

        .bloco-imovel__conteudo--direito
            span.ajuste Média:
            span.valor__negrito {{ media }}

    .bloco-imovel__alinhamento
        .bloco-imovel__alinhamento--conteudo
            span.barra-topo Menores que 50 ha
            span.valor__negrito {{ valorMenor }}

        .bloco-imovel__alinhamento--conteudo
            span.barra-topo de 50 ha a 1.000 ha
            span.valor__negrito {{ valorMedio }}

        .bloco-imovel__alinhamento--conteudo
            span.barra-topo Maior que 1.000 ha
            span.valor__negrito {{ valorMaior }}
</template>

<script>
export default {
    name: 'BlocoImovel',
    props: {
        imoveisValor: {
            type: String,
            default: () => ''
        },
        areaValor: {
            type: String,
            default: () => ''
        },
        media: {
            type: String,
            default: () => ''
        },
        valorMenor: {
            type: String,
            default: () => ''
        },
        valorMedio: {
            type: String,
            default: () => ''
        },
        valorMaior: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-imovel {
    width: 100%;
    background: var(--white);
    border-radius: 5px;
    display: flex;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    padding: 12px 10px 20px;
    flex-direction: column;
    height: 405px;
    .bloco-imovel__titulo {
        display: flex;
        padding-bottom: 8px;
    }
    .bloco-imovel__titulo--interno {
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        width: 80%;
        .negrito {
            font-weight: 600;
            font-size: 20px;
            color: var(--primary);
        }
    }
    .bloco-imovel__conteudo {
        display: flex;
        margin-bottom: 15px;
        &--esquerdo {
            display: flex;
            flex-direction: column;
            min-width: 58%;
        }
        &--direito {
            display: flex;
            flex-direction: column;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .bloco-imovel__alinhamento {
        display: flex;
        flex-direction: column;

        &--conteudo {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
        }
        .valor__negrito {
            font-weight: 700;
            color: var(--primary);
        }
    }
    .barra-topo::before {
        content: '';
        display: flex;
        width: 24px;
        height: 2px;
        background: var(--secondary-two);
        clear: both;
        margin-bottom: 5px;
    }
    .ajuste {
        margin-top: 7px;
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
